import { render, staticRenderFns } from "./List.vue?vue&type=template&id=18ce48a6&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=18ce48a6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ce48a6')) {
      api.createRecord('18ce48a6', component.options)
    } else {
      api.reload('18ce48a6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=18ce48a6&", function () {
      api.rerender('18ce48a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/Mention/List.vue"
export default component.exports